import { CircularProgress, Box } from "@mui/material";

const Loader = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight={300}
      width="100%"
    >
      <CircularProgress size={48} />
    </Box>
  );
};

export default Loader;
